import { render, staticRenderFns } from "./RealtimeData.vue?vue&type=template&id=33f09058&"
import script from "./RealtimeData.vue?vue&type=script&lang=js&"
export * from "./RealtimeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports